function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.classList.contains('reset__button')) return;
    
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    
    // Resume product video after modal closes
    setTimeout(() => {
      const productVideo = document.getElementById('productVideo');
      if (productVideo && productVideo.hasAttribute('autoplay') && productVideo.paused) {
        productVideo.play().catch((error) => {
          console.warn('Autoplay was prevented with the error: ', error);
        });
      }
    }, 100);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.addEventListener('touchstart', this.focusInHandling.bind(this));
    this.addEventListener('touchend', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    // Guard against undefined slides
    if (!currentSlide || !nextSlide) return;

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e = null) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      const input = e?.target;
      const isColor = !input?.name || input?.name?.toLowerCase() === 'color';
      const isDesktop = window.matchMedia("(min-width: 750px)").matches;
      // const shouldScroll = (isColor && !isDesktop) || isDesktop;
      const shouldScroll = false;

      //check if color changed
      const currentColor = this.currentVariant.option1;
      const colorChanged = this.previousColor !== currentColor;
      this.previousColor = currentColor; // Update previous color

      // Only update media when color changes
      if(colorChanged) {
        this.updateMedia(shouldScroll);
      }

      if(isColor){
        this.updateURL();
        this.updateInputs(input);
        this.refreshCompleteTheLook(this.currentVariant.id);

      }

      const priceSm = document.querySelector(".proce__sm.mobile_price .mb_price");
      const parentContainer = document.querySelector(".proce__sm.mobile_price");

      if (priceSm && parentContainer) {
        priceSm.innerHTML = formatMoney(this.currentVariant.price);
        const existingCompare = parentContainer.querySelector("s");
        if (existingCompare) {
          existingCompare.remove();
        }
        if(this.currentVariant.compare_at_price && (this.currentVariant.price < this.currentVariant.compare_at_price)) {
          const comparePrice = document.createElement("s");
          comparePrice.innerHTML = formatMoney(this.currentVariant.compare_at_price);
          comparePrice.style.marginLeft = "3px";
          priceSm.insertAdjacentElement("afterend", comparePrice); 
        }
      }


      const variantQuantity = window.variantQuantities[this.currentVariant.id];
      const targetElement = document.querySelector('.size-remaining-msg');
      const mobileTargetElement = document.querySelector('.arrival-edd');

      if (this.currentVariant.new_arrival_edd) {
                
        const notifyMsg = document.getElementById('notifyPopup');
        if(notifyMsg){
          notifyMsg.style.display = 'none'; 
        }
        
        
        const eddDate = new Date(this.currentVariant.new_arrival_edd);
        const currentDate = new Date();
        
        // Only show if the EDD date is in the future
        if (eddDate > currentDate) {
          mobileTargetElement.style.display = 'block';
          mobileTargetElement.style.padding = '10px 0';
          mobileTargetElement.style.margin = '0 0 15px 0';
          const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 
                             'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
          const formattedDate = `${monthNames[eddDate.getUTCMonth()]} ${eddDate.getUTCDate()}`;
          targetElement.textContent = `ARRIVING ${formattedDate}`;
          mobileTargetElement.textContent = `ARRIVING ${formattedDate}`;          
          mobileTargetElement.style.borderBottom = '2px solid #cccccc';
        } else {
          targetElement.textContent = '';
          mobileTargetElement.textContent = '';
          mobileTargetElement.style.display = 'none';
        }
      }
      
      else{
        if (mobileTargetElement) {
          mobileTargetElement.style.display = 'none';
        }
        if (targetElement) {
          targetElement.textContent = '';
        }
        if (mobileTargetElement) {
          mobileTargetElement.textContent = '';
          mobileTargetElement.style.borderBottom = 'none';
        }
      }
      
      // Only call setActiveVideo when color changes
      if (colorChanged) {
        this.setActiveVideo(this.currentVariant.option1);
      }
      
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    const Sku = document.querySelector(".product__description__sku span");
    
    Sku.innerText = this.currentVariant.sku;
    
  }

  updateInputs(input){
    if(!input){
      return;
    }

    let parent;
    let value;
    if(input.options?.[0]){
      value = handleize(input.options?.[0]);
      const id = `#product-color-swatch-${value}`;
      parent = document.querySelector(id);
    } else {
      value= input.value;
      parent = input.parentElement;
    }
    const labels = document.querySelectorAll(".product-color-swatches label");
    (Array.from(labels) ?? []).forEach(label => {
      label.classList.remove("color-swatch-checked")
    });
    if(parent){
      parent.classList.add("color-swatch-checked");
    }
    const label = document.querySelector(".product-selector-color-name");
    if(label){
      label.innerText = '('+value+')';
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  swymCallbackFn(swat){
    // your API calls go here
    
    document.addEventListener("swym:collections-loaded", function(){
      swat.initializeActionButtons(".product__media-list");
    })
  }

  // New method to refresh Complete The Look section
  async refreshCompleteTheLook(variantId) {
    //setTimeout(initMobileSwiper, 2000);
    
    const sectionId = this.dataset.section || 'main-product';
    const productInfo = document.querySelector('product-info');
    
    
    let completeLookSection = document.querySelector('.complete-look-section');
    if (!completeLookSection) {
      console.warn('Complete The Look not found on page');
      return;
    }

    try {
      // Fetch the updated section HTML
      const response = await fetch(`${this.dataset.url}?variant=${variantId}&section_id=${sectionId}`);
      const html = await response.text();
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const newSection = parsedHtml.querySelector('.complete-look-section');

      if (newSection) {
        // Replace or insert the new section
        if (completeLookSection) {
          completeLookSection.outerHTML = newSection.outerHTML;
          initializeVariantImageEvents();
        } 
    
        //if no complete look section for selected color, transfer to default position
        const ctlGrid = document.querySelector('.complete-look-grid-container');
        if(!ctlGrid){
          productInfo.style.setProperty('transition', 'top 0.15s ease-out', 'important');
          productInfo.style.removeProperty('top'); 
          //productInfo.style.setProperty('top', `170px`, 'important');
        }
      } else {
      console.log('No valid Complete The Look content; clearing content');
      completeLookSection.innerHTML = '';
    
     }
    } catch (error) {
      console.error('Error refreshing Complete The Look:', error);
      completeLookSection.innerHTML = '';
    }

    //setTimeout(initMobileSwiper, 500);
  }

updateMedia(isColor) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      const activeMedia = mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, isColor);
      
      const hasWishlistButton = activeMedia?.querySelector('button.swym-button.swym-add-to-wishlist.product-page-button');
    
      const existingButton = document.querySelector('button.swym-button.swym-add-to-wishlist.product-page-button');
      
      if(!hasWishlistButton && existingButton){
            const productId = existingButton.getAttribute('data-product-id');
            const productURL = existingButton.getAttribute('data-product-url');
            if(!productURL){
              return
            }
            let newURL = productURL.split("variant=")[0];
            newURL+=`variant=${this.currentVariant.id}`;
            
            const button = document.createElement("button");
            button.classList.add('swym-button');
            button.classList.add('swym-add-to-wishlist');
            button.setAttribute('data-with-epi', true);
            button.setAttribute('data-swaction', 'addToWishlist');
            button.setAttribute('data-product-id', productId);
            button.setAttribute('data-variant-id', this.currentVariant.id);
            button.setAttribute('data-product-url', productURL);

            
            activeMedia.append(button);
            setTimeout(()=> {
              window.SwymCallbacks.push(this.swymCallbackFn);
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
              
            })
          }
    });
    

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  setActiveVideo(currentVariant){
    setTimeout(function() {  
      document.querySelectorAll(".slider-mobile-gutter .product__media-list .product__media-item").forEach(element => {
        let dataVariantId = element.getAttribute('data-video-variant-color');
        if(dataVariantId == currentVariant){
          element.classList.remove('not-current-variant');

          const video = element ? element.querySelector('video') : null;
          if (video) {
            video.play();
            //video.controls = false;
          }
        }
      });
    }, 500);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const selectedColor = this.querySelector(':checked').value;
      this.setInputAvailability(optionInputs, availableOptionInputsValue, selectedColor);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const soldOutLabel = document.getElementById('pdp_sold-out');
        /*this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );*/

        const isSoldOut = addButtonUpdated ? addButtonUpdated.hasAttribute('soldout') : true;
        const mobileCtaBtnText = document.querySelector('.mobile-cta-btn-text');

        // Only show sold out if not set to continue selling
        if (this.currentVariant.inventory_policy != 'continue') {   
          this.toggleAddButton(isSoldOut, window.variantStrings.soldOut);
          if(isMobileDevice()){
            if(mobileCtaBtnText){
              mobileCtaBtnText.textContent = window.variantStrings.addToCart;
            }
          }
        }
        else{                  
          if(mobileCtaBtnText){
            mobileCtaBtnText.textContent = "PREORDER";
          }
        }

        if(isSoldOut){
          const variantId = this.currentVariant.id;
          const variantSize = this.currentVariant.option2;
          if (!isMobileDevice()) {
            openPopup(variantId, variantSize, false);
            document.querySelector('.product-form__submit.hide-mobile').style.display = 'none';
          }
        }else{
          closePopupHandler();
          document.querySelector('.product-form__submit.hide-mobile').style.display = 'block';
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('soldout', 'soldout');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('soldout');
      const mobileCtaBtnText = document.querySelector('.mobile-cta-btn-text');
      if(mobileCtaBtnText){
        mobileCtaBtnText.textContent = window.variantStrings.addToCart;
      }
      addButtonText.textContent =  window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions,  selectedColor = null) {

    if (selectedColor) {
      const variantData = this.getVariantData();
      listOfOptions.forEach((input) => {
        const sizeValue = input.getAttribute('value');
        const correctVariant = variantData.find(variant => 
          variant.option1 === selectedColor && variant.option2 === sizeValue
        );
        
        if (correctVariant) {
          input.setAttribute('variant-id', correctVariant.id);
          input.setAttribute('data-restocking-edd', correctVariant.restocking_edd || '');
        }
      });
    }

    listOfOptions.forEach((input) => {
      const wrapper = input.closest('.size-option__wrapper'); // Find the wrapper element
      const notifyDivClass = 'notify-me'; // Class to identify the dynamically added <div>
      
      // Check if the input's value is in the available options list
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        
        // Remove the notify-me <div> if it exists
        const existingDiv = wrapper.querySelector(`.${notifyDivClass}`);
        if (existingDiv) {
          existingDiv.remove();
        }
      } else {
        input.classList.add('disabled');
        
        // Add the notify-me <div> if it doesn't already exist
        if (!wrapper.querySelector(`.${notifyDivClass}`)) {
          const notifyDiv = document.createElement('div');
          notifyDiv.className = 'notify-me hide-desktop';
  
          // Create the anchor element
          const anchor = document.createElement('a');
          anchor.href = 'javascript:void(0);';
          anchor.className = 'notify_me';
          anchor.setAttribute('variant-id', input.getAttribute('data-variant-id')); // Assuming the variant ID is stored in a data attribute
          anchor.setAttribute('variant-size', input.getAttribute('value'));
          anchor.textContent = 'Notify me';
  
          // Append the anchor to the notify div
          notifyDiv.appendChild(anchor);
  
          // Append the notify div to the wrapper
          wrapper.appendChild(notifyDiv);
        }
      }
    });

    notifyLinksMobile();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => {
        return radio.checked
      }).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            initializeVariantImageEvents();
          }

          //setTimeout(initMobileSwiper, 500);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

function handleize(str) {
  return str
      .toLowerCase()           // Convert the string to lowercase
      .replace(/\s+/g, '-')    // Replace spaces with hyphens
      .replace(/[^a-z0-9\-]/g, '') // Remove any characters that are not letters, numbers, or hyphens
      .replace(/-+/g, '-')     // Replace multiple hyphens with a single hyphen
      .replace(/^-|-$/g, '');  // Remove leading or trailing hyphens
}

customElements.define('product-recommendations', ProductRecommendations);

// PDP mobile sticky ATC + size sheet live in assets/pdp-mobile-atc.js (non-deferred from buy-buttons).
// Call window.setMobileSizeSelectorOpen from deferred code below (notify-me / size → add).

document.addEventListener('DOMContentLoaded', function () {
  function handleTabs(container) {
    const tabs = container.querySelectorAll('.tab');
    const tabPanes = container.querySelectorAll('.tab-pane');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const target = container.querySelector(`#${this.dataset.tab}`);

        const tabType = this.dataset.type;
        tabs.forEach(t => t.classList.remove('active'));
        tabPanes.forEach(p => p.classList.remove('active'));
          this.classList.add('active');
          target.classList.add('active');

          if(tabType == 'material'){
            const fabric = this.dataset.fabric;
            target.textContent = getMaterialDescription(fabric);
           // target.textContent = 'New Content';
          }
      });
    });
  }

  const mobileTabsContainer = document.querySelector('.product-tabs.hide-desktop');
  const desktopTabsContainer = document.querySelector('.product-tabs.hide-mobile');

  if (mobileTabsContainer) {
    handleTabs(mobileTabsContainer);
  }

  if (desktopTabsContainer) {
    handleTabs(desktopTabsContainer);
  }
});

// Function to get material description
function getMaterialDescription(materialName) {
  const capitalizedMaterialName = materialName
  .toLowerCase()  // Convert entire string to lowercase first
  .split(' ')     // Split by space into an array of words
  .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize each word
  .join(' ');     // Join the words back into a single string

  if (materialDescriptions.hasOwnProperty(capitalizedMaterialName)) {
    return materialDescriptions[capitalizedMaterialName];
  } else {
    return capitalizedMaterialName;
  }
}

function notifyLinksMobile(){
  const notifyLinks = document.querySelectorAll('.notify_me');
  notifyLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = e.target.getAttribute('variant-id');
      const variantSize = e.target.getAttribute('variant-size');
      openPopup(variantId, variantSize);
    });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  
  const popup = document.getElementById('notifyPopup');
  const submitButton = document.getElementById('submitNotify');
  const notifyVariant = document.getElementById('notifyVariant');
  const notifyMsg = document.getElementById('notifyMsg');
  const emailInput = document.getElementById('notifyEmail');
  const notifyPhone = document.getElementById('notifyPhone');
  const closePopup = document.getElementById('closePopup');
  const formBtns = document.getElementById('mobile_cta-wrapper');

  notifyLinksMobile();
  window.notifyLinksMobile = notifyLinksMobile;

  

  window.openPopup = (variantId, variantSize, isMobile=true) => {
    
    popup.style.display = 'block';
    notifyVariant.value = variantId;
    
    // Check for restock date
    let restockMessage = '';
    if(!isMobile){
    const variantSelects = document.querySelector('variant-selects, variant-radios');
    if (variantSelects) {
      const variantData = variantSelects.getVariantData();
      const variant = variantData.find(v => v.id.toString() === variantId.toString());
      
      if (variant && variant.restocking_edd && !variant.available) {
        const restockDate = new Date(variant.restocking_edd);
        const currentDate = new Date();
        
        if (restockDate > currentDate) {
          const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 
                             'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
          const formattedDate = `${monthNames[restockDate.getUTCMonth()]} ${restockDate.getUTCDate()}`;
          restockMessage = `RESTOCKING ${formattedDate}. `;
        }
      }
    }
  }
     else if(isMobile){
     // Find the input element that corresponds to this variant size
     const sizeValue = variantSize; // This comes from the notify button's variant-size attribute
     const sizeInputs = document.querySelectorAll('.size-selection input[name="Size"]');
     let restockingEdd = '';
     
     // Find the input with matching size value
     sizeInputs.forEach(input => {
       if (input.getAttribute('value') === sizeValue) {
         restockingEdd = input.getAttribute('data-restocking-edd') || '';
       }
     });
     
     
     if(restockingEdd){
       const restockDate = new Date(restockingEdd);
       const currentDate = new Date();
       
       if(restockDate > currentDate){
         const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 
         'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
         const formattedDate = `${monthNames[restockDate.getUTCMonth()]} ${restockDate.getUTCDate()}`;
         restockMessage = `RESTOCKING ${formattedDate}. `;
       }
     }
  }
    
    notifyMsg.innerHTML = `${restockMessage}Be notified by email or SMS when size ${variantSize} becomes available.`;
    if(isMobile){
      if (typeof window.setMobileSizeSelectorOpen === 'function') {
        window.setMobileSizeSelectorOpen(false);
      }
      formBtns.style.display = 'none';
      // document.body.style.overflow = 'hidden';
    }
    submitButton.disabled = false;
  };

  window.closePopupHandler = () => {
    popup.style.display = 'none';
    document.body.style.overflow = 'auto';
    formBtns.style.display = 'block';
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  if(closePopup){
  closePopup.addEventListener('click', closePopupHandler);
  }
  

  if (submitButton) {
    submitButton.addEventListener('click', async () => {
      const email = emailInput.value.trim();
      const phone = notifyPhone.value.trim();
      const variant = notifyVariant.value;

      // Validate email
      const isEmailValid = validateEmail(email);
      if (email) {
        if (!isEmailValid) {
          emailInput.classList.add('invalid');
          notifyMsg.innerHTML = 'Please enter a valid email or phone number.';
          return;
        }
        emailInput.classList.remove('invalid');
        notifyPhone.classList.remove('invalid');
      }

      // Validate phone
      const isPhoneValid = validatePhone(phone);
      if (phone) {
        if (!isPhoneValid) {
          notifyPhone.classList.add('invalid');
          notifyMsg.innerHTML = 'Please enter a valid phone number (e.g., +12345678901).';
          return;
        }
        notifyPhone.classList.remove('invalid');
        emailInput.classList.remove('invalid');
      }

      // Require at least one valid field
      if (!isEmailValid && !isPhoneValid) {
        notifyMsg.innerHTML = 'Please enter a valid email or phone number.';
        emailInput.classList.add('invalid');
        notifyPhone.classList.add('invalid');
        return;
      }

      try {
        await submitNotifyMe(email, phone, variant);
        notifyMsg.innerHTML = 'Your details have been submitted.';
        emailInput.value = '';
        notifyPhone.value = '';
        emailInput.classList.remove('invalid');
        notifyPhone.classList.remove('invalid');
        submitButton.disabled = true;
      } catch (error) {
        notifyMsg.innerHTML = 'There is an error!!';
      }
    });
  }

  window.addEventListener('click', (event) => {
    if (event.target === popup) {
      closePopupHandler();
    }
  });
});

function normalizePhone(phone) {
  const phoneRegex = /^(?:\+?1)?(\d{10})$/; // Captures 10-digit US number with or without +1
  const match = phone.match(phoneRegex);

  return match ? `+1${match[1]}` : null; // Always return in E.164 format
}

function submitNotifyMe(email, phone, variant) {
  const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UpVYci`;

  // Determine channels and profile attributes based on input
  let channels = [];
  let profileAttributes = {};

  if (email) {
    channels.push('EMAIL');
    profileAttributes.email = email;
  }

  if (phone) {
    channels.push('SMS');
    profileAttributes.phone_number = normalizePhone(phone);
  }

  // Ensure at least one channel is present
  if (channels.length === 0) {
    console.error("At least one contact method (email or phone) is required.");
    return Promise.reject("At least one contact method (email or phone) is required.");
  }

  const options = {
    method: 'POST',
    headers: {
      'accept': 'application/json',
      'revision': '2024-02-15',
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: channels,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variant}`
            }
          }
        }
      }
    })
  };


  return fetch(url, options)
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(`Failed to submit: ${JSON.stringify(err)}`);
        });
      }
      return response.ok;
    })
    .catch(error => {
      console.error("Error submitting notification request:", error);
      throw error;
    });
}

function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

function validatePhone(phone) {
  const phoneRegex = /^(?:\+1|1)?\d{10}$/;
  return phoneRegex.test(phone);
}

// Function to detect mobile device
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}


document.addEventListener('DOMContentLoaded', function() {
  // Size → auto-add is mobile size-sheet UX only. Use viewport, not UA
  // (desktop DevTools "mobile UA" / touch laptops were leaking this onto desktop).
  var isMobileAtcViewport = window.matchMedia('(max-width: 767px)').matches;

  if (isMobileAtcViewport) {
    const sizeInputs = document.querySelectorAll('.size-option__wrapper input[type="radio"]');

    sizeInputs.forEach(input => {
      input.addEventListener('click', function() {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        if (!this.classList.contains('disabled')) {
          const formId = this.getAttribute('form');
          const form = document.getElementById(formId);
          
          if (form) {
            const submitButton = form.querySelector('button[name="add"]');
            if (submitButton) {
              setTimeout(() => {
                if (typeof window.setMobileSizeSelectorOpen === 'function') {
                  window.setMobileSizeSelectorOpen(false);
                }
                submitButton.removeAttribute('disabled');
                submitButton.click();
              }, 100);
            }
          }
        }
      });
    });

  } else {
    const sizeSelectorBtn = document.getElementById('sizeSelector');
    if (sizeSelectorBtn) {
      sizeSelectorBtn.remove();
    }
  }
});

function updateCardMediaAndPrice(event, dataSrc, dataUrl, dataQty, dataPrice, dataSalePrice, dataInventoryPolicy) {
  const cardInner = event.target.closest('.card');
  if (!cardInner) return;

  const swatchEl =
    event && event.target && event.target.closest ? event.target.closest('.variant-swatch') : null;
  const fitgroupSibling = swatchEl ? swatchEl.getAttribute('data-fitgroup-sibling') : null;
  const fitgroupUrl = swatchEl ? swatchEl.getAttribute('data-fitgroup-url') : '';

  const gallery = cardInner.querySelector('.card-image-gallery');
  const anchor = cardInner.querySelector('a');
  const media = cardInner.querySelector('img');
  let priceContainer = cardInner.querySelector('.price__container'); 
  let soldOutSpan = cardInner.querySelector('.sold-out');
  let preorderSpan = cardInner.querySelector('.preorder');
  let priceHTML = "";

  if (!gallery) {
    if (media) media.src = dataSrc;
    if (anchor) anchor.href = dataUrl;
  }

  if (dataUrl && swatchEl) {
    const productIdKey = swatchEl.getAttribute('data-product-id');
    const productId = productIdKey?.includes('-')
      ? productIdKey.slice(0, productIdKey.indexOf('-'))
      : productIdKey;
    const cardWrapper = cardInner.closest('.card-wrapper') || cardInner;
    if (productId && cardWrapper) {
      const dynamicLink = cardWrapper.querySelector('.variant_dynamic_link_' + productId);
      if (dynamicLink) dynamicLink.href = dataUrl;
      const titleLink = cardWrapper.querySelector('.card-style-title');
      if (titleLink) titleLink.href = dataUrl;
    }
  }
  
  // Extract numeric values from price strings (remove currency symbols, commas, etc.)
  const extractPrice = (priceString) => {
    if (!priceString) return null;
    const num = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    return isNaN(num) ? null : num;
  };
  
  // Get inventory policy and quantity from parameters (similar to dataSalePrice)
  const inventoryPolicy = dataInventoryPolicy;
  const quantity = parseInt(dataQty) || 0;
  
  // Find target div - either has price container, sold-out span, or preorder span
  let targetDiv = null;
  if (soldOutSpan && soldOutSpan.parentElement) {
    targetDiv = soldOutSpan.parentElement;
  } else if (preorderSpan && preorderSpan.parentElement) {
    targetDiv = preorderSpan.parentElement;
  } else if (priceContainer && priceContainer.parentElement) {
    targetDiv = priceContainer.parentElement;
  }
    // Remove any existing preorder-text element first to avoid duplicates
    const card = cardInner.closest('.card-wrapper');
    const existingPreorderText = card ? card.querySelector('.preorder-text') : null;
    if (existingPreorderText) {
      existingPreorderText.remove();
    }

    //also check if div class sold-out div exist remove this as well
    const existingSoldOutDiv = card ? card.querySelector('.sold-out') : null;
    if (existingSoldOutDiv) {
      existingSoldOutDiv.remove();
    }

  if (quantity > 0 || inventoryPolicy === 'continue') {    
    const salePriceNum = extractPrice(dataSalePrice);
    const regularPriceNum = extractPrice(dataPrice);

    if (dataSalePrice && salePriceNum !== null && regularPriceNum !== null && salePriceNum > regularPriceNum) {
            // Generate sale price HTML
            priceHTML = `
                <div class="price__sale">
                    <span>
                        <s class="price-item price-item--regular">${dataSalePrice}</s>
                    </span>
                    <span class="price-item price-item--sale price-item--last">
                        ${dataPrice}
                        <span id="pdp_sold-out"></span>
                    </span>
                </div>
            `;
        } else {
            // Generate regular price HTML
            priceHTML = `
                <div class="price__regular">
                    <span class="price-item price-item--regular">${dataPrice}</span>
                    <span id="pdp_sold-out"></span>
                </div>
            `;
            const parentDiv = priceContainer ? priceContainer.closest('.price--on-sale') : null;
      if (parentDiv) {
        parentDiv.classList.remove('price--on-sale');
      }
    }

    // Update the content — preorder is shown via product-card image badge
    if (priceContainer) {
      priceContainer.innerHTML = priceHTML;
    } else if (targetDiv) {
      // If there was a sold-out or preorder span, replace it with full price structure
      targetDiv.innerHTML = `
        <div class="price">
          <div class="price__container">
            ${priceHTML}
          </div>
        </div>
      `;
    }
  } else {
    const esc = function (s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    };
    const cardRoot = cardInner.closest('.card-wrapper') || cardInner.closest('[id^="card-product-"]');
    const fitMsg = cardRoot ? cardRoot.getAttribute('data-fitgroup-msg') : '';
    const soldCard = (cardRoot && cardRoot.getAttribute('data-sold-out-card')) || 'SOLD OUT';

    if (fitgroupSibling === '1' && fitMsg) {
      const urlAttr =
        fitgroupUrl && fitgroupUrl.length
          ? ` data-fitgroup-url="${esc(fitgroupUrl)}"`
          : '';
      const labelHtml = `<span class="sold-out"${urlAttr}>${esc(fitMsg)}</span>`;
      if (targetDiv) {
        targetDiv.innerHTML = labelHtml;
      } else if (priceContainer && priceContainer.parentElement) {
        priceContainer.parentElement.innerHTML = labelHtml;
      }
    } else if (targetDiv) {
      targetDiv.innerHTML = '<span class="sold-out">' + esc(soldCard) + '</span>';
    } else if (priceContainer && priceContainer.parentElement) {
      priceContainer.parentElement.innerHTML = '<span class="sold-out">' + esc(soldCard) + '</span>';
    }
  }
 
}

function setActiveClass(targetElement) {
  const siblings = targetElement.parentElement.children;
  for (let sibling of siblings) {
      if (sibling !== targetElement) {
          sibling.classList.remove('active');
      }
  }
  targetElement.classList.add('active');
}

function handleImageClick(event) {
  // Ensure we are getting the correct .variant-swatch element
  const swatch = event.target.closest('.variant-swatch');
  if (!swatch) return;

  // Now safely get data attributes from the .swatch element inside it
  const swatchElement = swatch.querySelector('.swatch');
  if (!swatchElement) return;

  const dataSrc = swatchElement.getAttribute('data-src');
  const dataUrl = swatchElement.getAttribute('data-url');
  const dataQty = swatchElement.getAttribute('data-qty');
  const dataPrice = swatchElement.getAttribute('data-price');
  const dataSalePrice = swatchElement.getAttribute('data-sale-price');
  const dataInventoryPolicy = swatchElement.getAttribute('data-inventory-policy');

  if (dataSrc && dataUrl) {
    updateCardMediaAndPrice(event, dataSrc, dataUrl, dataQty, dataPrice, dataSalePrice, dataInventoryPolicy);
  }

  setActiveClass(swatch); // Set active class on the clicked swatch

  if (window.ProductCardBadges && typeof window.ProductCardBadges.refreshFromSwatch === 'function') {
    window.ProductCardBadges.refreshFromSwatch(swatch);
  }
}

function initializeVariantImageEvents() {
  const variantSwatches = document.querySelectorAll('.variant-swatch');
  variantSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', handleImageClick);
  });

}

function toggleClassOnVisibility() {
  const elementToModify = document.querySelector('.product__info-wrapper.grid__item');
  const elementToCheck = document.querySelector('.grid__item.product__media-wrapper');

  if (!elementToModify || !elementToCheck) return;

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0]; // Only handle the first entry

    if (entry.isIntersecting) {
      // If .related-products is in the viewport, add class to .product__info-wrapper.grid__item
      elementToModify.classList.remove('pos-relativ');
    } else {
      // If .related-products is out of the viewport, remove the class from .product__info-wrapper.grid__item
      elementToModify.classList.add('pos-relativ');
    }
  });

  // Observe the .related-products element
  observer.observe(elementToCheck);
}

// Call the function
toggleClassOnVisibility();

/*document.addEventListener('DOMContentLoaded', function () {
  initializeVariantImageEvents();
});

document.addEventListener('section:load', function () {
  initializeVariantImageEvents();
});*/